import { hmplusLimitedReleasesListConstants } from "../_redux-constants";
import { hmplusLimitedReleasesListService } from "../../_services";

function getHMplusLimitedReleasesList(queryParams) {
  function getHMplusLimitedReleasesListLoad() {
    return {
      type: hmplusLimitedReleasesListConstants.HMPLUS_LIMITED_RELEASES_LIST_LOADING,
    };
  }
  function getHMplusLimitedReleasesListSuccess(data) {
    return {
      type: hmplusLimitedReleasesListConstants.HMPLUS_LIMITED_RELEASES_LIST_SUCCESS,
      data,
    };
  }
  function getHMplusLimitedReleasesListFailure(error) {
    return {
      type: hmplusLimitedReleasesListConstants.HMPLUS_LIMITED_RELEASES_LIST_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(getHMplusLimitedReleasesListLoad());
    return hmplusLimitedReleasesListService
      .getHMplusLimitedReleasesList(queryParams)
      .then(
        (data) => {
          dispatch(getHMplusLimitedReleasesListSuccess(data));
        },
        (error) => {
          dispatch(getHMplusLimitedReleasesListFailure(error?.toString()));
        }
      );
  };
}

export const hmplusLimitedReleasesListActions = {
  getHMplusLimitedReleasesList,
};
